import { FC, PropsWithChildren, useState } from 'react';

import { FileDataState } from '@/types/data.type';

import { LibraryFileQueueContext } from './LibraryFileQueue.context';

export const LibraryFileQueueProvider: FC<PropsWithChildren> = ({
    children,
}) => {
    const [fileMap, setFileMap] = useState<Record<string, File>>({});
    const [fileStateMap, setFileStateMap] = useState<
        Record<string, FileDataState>
    >({});

    return (
        <LibraryFileQueueContext.Provider
            value={{ fileMap, fileStateMap, setFileMap, setFileStateMap }}>
            {children}
        </LibraryFileQueueContext.Provider>
    );
};
